//注册 custom下的全部组件
export default {
  install(Vue) {
    let modules = require.context('../custom',  true, /^.*\.vue$/, 'sync');
    modules.keys().forEach(element => {
        let name = element.replace(/^\.\/(.*)\.vue$/,'$1');
        Vue.component(name,modules(element).default);
    });
  },
};